module.exports = __webpack_public_path__ + "static/health-care-advancements-970a7543044c65799df75dd7965ac8c7.png";